import { IWidgetDefinition, IWidget } from '../../common/core';
import { IFuseSortSettings } from './fuse-sort.settings';
import SortWidgetDefinition from '../sort.widget/sort';
import { SortData, ISortOption } from '../sort.widget/sort';

const template = require('./fuse-sort.html');
const styles = require('./fuse-sort.scss').toString();

export class FuseSortData extends SortData {
  sortOption: ISortOption;
  total: number;
  searchString = '';
  prevSearchTerm: any;

  relevanceLabel = 'Relevance';
  newestLabel = 'Newest';

  constructor(public widget: IWidget<FuseSortData, IFuseSortSettings, null>) {
    super(widget);
  }

  init() {
    super.init();

    this.sortOption = this.getMatchedItem();
  }

  get pageStart() {
    if (!this.widget.service.seriesParam.page) {
      return 0;
    }

    return (this.widget.service.seriesParam.page - 1) * this.widget.service.seriesParam.per_page + 1;
  }

  get pageEnd() {
    if (!this.widget.service.seriesParam.page) {
      return 0;
    }

    return Math.min(this.widget.service.seriesParam.page * this.widget.service.seriesParam.per_page, this.total);
  }

  setSearchString() {
    var widget = this.getSearchWidget();
    this.searchString = widget?.state?.searchString || '';
  }

  getSearchWidget() {
    const widget = this.widget.service.getAllWidgets()
      .sort((a, b) => a.type === 'fuse-search' ? -1 : 0)
      .find(w => ['fuse-search', 'search'].includes(w.type));
    return widget;
  }

  changeSortIfNecessary(matchedItem, params) {
    // CUST-13825 (Relevance should be only available when there is search term. otherwise switch to another sort)
    if (matchedItem && !matchedItem.disabled && matchedItem.label == this.relevanceLabel) {
      var sw = this.getSearchWidget();
      if (sw && !sw.state.searchString) {
        // Newest should be shown first
        var newSortOption = this.widget.settings.options.filter(o => o.label == this.newestLabel)[0];
        // but in case of missed Newest just use first one except Relevance
        if (!newSortOption) {
          newSortOption = this.widget.settings.options.filter(o => o.label != this.relevanceLabel)[0];
        }
        if (newSortOption) {
          this.changeSort(params, newSortOption.field + ' ' + newSortOption.order);
          return;
        }
      }
    }
    super.changeSortIfNecessary(matchedItem, params);
  }

  setSort(option: ISortOption) {
    // CUST-13825 (Relevance should be only available when there is search term)
    if (!option.disabled && option.label == this.relevanceLabel) {
      var sw = this.getSearchWidget();
      if (sw && !sw.state.searchString) {
        return;
      }
    }
    super.setSort(option);
  }

  isItemDisabled(item) {
    if (!item.disabled && item.label == this.relevanceLabel) {
      var sw = this.getSearchWidget();
      if (sw && !sw.state.searchString) {
        return true;
      }
      return false;
    }
    if (item.disabled && item.disabled(this.widget)) {
      return true;
    }
  }

  beforeSearch(params: any): void {
    super.beforeSearch(params);

    // CUST-13825 (switch to Relevance if now there is Newest and some search term was added)
    var sw = this.getSearchWidget();
    var items = this.widget.settings.options;

    if (sw && !this.prevSearchTerm && sw.state.searchString) {

      var relevanceSort;
      var nonRelevanceSorts = {};
      items.forEach(it => {
        if (it.label == this.relevanceLabel) {
          relevanceSort = `${it.field} ${it.order}`;
        } else {
          nonRelevanceSorts[`${it.field} ${it.order}`] = 1;
        }
      });

      if (nonRelevanceSorts[params.sort]) {
        params.sort = relevanceSort;
        this.widget.service.seriesParam.sort = params.sort;
        this.widget.data.initSort();
      }
    }
    this.prevSearchTerm = sw.state.searchString;

    this.setSearchString();
  }

  setSelection() { }

  get selection() {
    return this.sortBy + ' ' + this.sortOrder;
  }
  set selection(newValue) {
    var parts = newValue.split(' ');
    var newSort: ISortOption = {
      order: <'asc' | 'desc'>parts.pop(),
      field: parts.join(' '),
      label: ''
    };
    this.setSort(newSort);
  }
}

export const FuseSortWidgetDefinition: IWidgetDefinition<FuseSortData, IFuseSortSettings, null> = {
  ...SortWidgetDefinition,
  init(widget) {
    widget.data = new FuseSortData(widget);
  },
  onData(widget, data) {
    widget.data.total = data.total;
  },
  template,
  styles,
};
